"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SparkDAO = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _JsSparkDAO2 = require("./JsSparkDAO");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SparkDAO = /*#__PURE__*/function (_JsSparkDAO) {
  (0, _inherits2.default)(SparkDAO, _JsSparkDAO);

  var _super = _createSuper(SparkDAO);

  function SparkDAO(sparkMapper, commentMapper, storeInterface, auth, firestore, functions) {
    var _this;

    (0, _classCallCheck2.default)(this, SparkDAO);
    _this = _super.call(this, sparkMapper, commentMapper, storeInterface, auth, firestore, functions);
    return (0, _possibleConstructorReturn2.default)(_this, (0, _assertThisInitialized2.default)(_this));
  }
  /**
   * Get a single Spark record
   * @param id
   */


  (0, _createClass2.default)(SparkDAO, [{
    key: "getSpark",
    value: function () {
      var _getSpark = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(id) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", (0, _get2.default)((0, _getPrototypeOf2.default)(SparkDAO.prototype), "getSpark", this).call(this, id));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getSpark(_x) {
        return _getSpark.apply(this, arguments);
      }

      return getSpark;
    }()
  }, {
    key: "setSpark",
    value:
    /**
     * Create or update a Spark record in Firestore
     * @param spark
     */
    function () {
      var _setSpark = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(spark) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", (0, _get2.default)((0, _getPrototypeOf2.default)(SparkDAO.prototype), "setSpark", this).call(this, spark));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setSpark(_x2) {
        return _setSpark.apply(this, arguments);
      }

      return setSpark;
    }()
  }, {
    key: "getSparkList",
    value:
    /**
     * @deprecated Use getCachedSparkList()
     *
     * Get a collection of Sparks from Firestore
     * @param source - the Firestore source, either cache or server
     * @param limit - maximum number of records to retrieve
     */
    function () {
      var _getSparkList = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var source,
            limit,
            _args3 = arguments;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                source = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : 'default';
                limit = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 150;
                return _context3.abrupt("return", (0, _get2.default)((0, _getPrototypeOf2.default)(SparkDAO.prototype), "getSparkList", this).call(this, source, limit));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getSparkList() {
        return _getSparkList.apply(this, arguments);
      }

      return getSparkList;
    }()
    /**
     * Get a collection of cached Sparks from a Cloud Function
     */

  }, {
    key: "getCachedSparkList",
    value: function () {
      var _getCachedSparkList = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", (0, _get2.default)((0, _getPrototypeOf2.default)(SparkDAO.prototype), "getCachedSparkList", this).call(this));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getCachedSparkList() {
        return _getCachedSparkList.apply(this, arguments);
      }

      return getCachedSparkList;
    }()
    /**
     * Efficient retrieval of the Spark feed using local caching as appropriate
     */

  }, {
    key: "refreshSparkCache",
    value: function refreshSparkCache() {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(SparkDAO.prototype), "refreshSparkCache", this).call(this);
    }
  }, {
    key: "sparkCacheNeedsRefresh",
    value:
    /**
     * Determine if the sparkCacheNeeds a refresh
     * @return {boolean}
     */
    function sparkCacheNeedsRefresh() {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(SparkDAO.prototype), "sparkCacheNeedsRefresh", this).call(this);
    }
    /**
     * Forced retrieval of SparkList data from Firestore local cache. Used immediately on first load.
     */

  }, {
    key: "populateSparkListFromCacheOnly",
    value: function () {
      var _populateSparkListFromCacheOnly = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return (0, _get2.default)((0, _getPrototypeOf2.default)(SparkDAO.prototype), "populateSparkListFromCacheOnly", this).call(this);

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function populateSparkListFromCacheOnly() {
        return _populateSparkListFromCacheOnly.apply(this, arguments);
      }

      return populateSparkListFromCacheOnly;
    }()
    /**
     * Rotates the the array of data predictably based on the hour and day of the year
     * Exists to give the feeling of some randomness in the display order.
     * This will likely be removed in future versions.
     * @param array
     */

  }, {
    key: "getSparkComments",
    value:
    /**
     * Get a collection of Sparks from Firestore
     * @param id - The id of the spark
     * @param limit - maximum number of records to retrieve
     * @param startAfterId
     * @param source - the Firestore source, either cache or server
     */
    function () {
      var _getSparkComments = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(id) {
        var limit,
            startAfterId,
            source,
            _args6 = arguments;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                limit = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : 10;
                startAfterId = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : undefined;
                source = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : 'default';
                return _context6.abrupt("return", (0, _get2.default)((0, _getPrototypeOf2.default)(SparkDAO.prototype), "getSparkComments", this).call(this, id, limit, startAfterId, source));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getSparkComments(_x3) {
        return _getSparkComments.apply(this, arguments);
      }

      return getSparkComments;
    }()
  }, {
    key: "setSparkComment",
    value: function () {
      var _setSparkComment = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(comment) {
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", (0, _get2.default)((0, _getPrototypeOf2.default)(SparkDAO.prototype), "setSparkComment", this).call(this, comment));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function setSparkComment(_x4) {
        return _setSparkComment.apply(this, arguments);
      }

      return setSparkComment;
    }()
  }, {
    key: "deleteSparkComment",
    value: function deleteSparkComment(comment) {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(SparkDAO.prototype), "deleteSparkComment", this).call(this, comment);
    }
  }, {
    key: "subscribeToSparkComments",
    value: function () {
      var _subscribeToSparkComments = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(id, callback) {
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", (0, _get2.default)((0, _getPrototypeOf2.default)(SparkDAO.prototype), "subscribeToSparkComments", this).call(this, id, callback));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function subscribeToSparkComments(_x5, _x6) {
        return _subscribeToSparkComments.apply(this, arguments);
      }

      return subscribeToSparkComments;
    }()
  }, {
    key: "unsubscribeFromSparkComments",
    value: function unsubscribeFromSparkComments() {
      (0, _get2.default)((0, _getPrototypeOf2.default)(SparkDAO.prototype), "unsubscribeFromSparkComments", this).call(this);
    }
  }], [{
    key: "rotate",
    value: function rotate(array) {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(SparkDAO), "rotate", this).call(this, array);
    }
  }]);
  return SparkDAO;
}(_JsSparkDAO2.JsSparkDAO);

exports.SparkDAO = SparkDAO;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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